import HttpService from "@/services/http-service";
import Advertisement, {SearchAdvertisementRequestParam} from "@/entities/advertisement";
import { pageMapperBuilder, Paginated } from "@/pagination";
import AsyncPaginatedRequest from "@/services/async-paginated-request";
import { LazyAsyncIter } from "@/iterators";

export default class AdvertisementService extends HttpService {
    public listAdvertisements(params: SearchAdvertisementRequestParam): AsyncIterator<Paginated<Advertisement>> {
        const asyncReq = new AsyncPaginatedRequest<AdvertisementDTO>(
            "get",
            "advertisements",
            params,
            undefined,
            this.httpClient
        )[Symbol.asyncIterator]();

        return new LazyAsyncIter(asyncReq).map(pageMapperBuilder(microSiteFromDTO));
    }

    public async createAdvertisements(advertisement: Advertisement): Promise<void> {
        await this.httpClient.post('advertisements',advertisement)
    }

    public async getAdvertisement(advertisementId: number): Promise<Advertisement> {
        const { data } = await this.httpClient.get(`advertisements/${advertisementId}`);
        return data;
    }

    public async updateAdvertisement(advertisementId: number, advertisement: Advertisement,): Promise<void> {
        await this.httpClient.put(`advertisements/${advertisementId}`,advertisement)
    }

    public async deleteAdvertisement(advertisementId: number): Promise<void> {
        await this.httpClient.delete(`advertisements/${advertisementId}`);
    }
}

export interface AdvertisementDTO {
    id?: number;
    title: string;
    description: string;
    body: string;
    created_at?: string;
    updated_at?: string;
}

export function microSiteFromDTO(dto: AdvertisementDTO): Advertisement {
    return new Advertisement({
        id: dto.id,
        title: dto.title,
        description: dto.description,
        body: dto.body,
        created_at: dto.created_at,
        updated_at: dto.updated_at ,
    });
}
